import {useMemo} from 'react';
import {DeviceType} from '../incase-domain/common/DeviceType.enum';
import {IPresentation} from '../incase-domain/presentation';
import {ISlide} from '../incase-domain/slide';

export interface SlideBackground {
    effectiveBackgroundColor: string;
    effectiveBackgroundImage: string | undefined;
}

const SLIDE_COLOR_DEFAULT = '#ffffff';

function resolveBackgroundImage(
    slideColor: string | null | undefined,
    slideImage: string | undefined,
    presentationImage: string | undefined
): string | undefined {
    if (slideColor && !slideImage) return undefined;
    return slideImage || presentationImage;
}

function selectDeviceImages(
    isDesktop: boolean,
    slide: ISlide | undefined,
    presentation: IPresentation | undefined
): {slideImage: string | undefined; presentationImage: string | undefined} {
    return {
        slideImage: isDesktop ? slide?.slideBackground : slide?.slideMobileBackground,
        presentationImage: isDesktop ? presentation?.presentationBackground : presentation?.presentationMobileBackground,
    };
}

export function getEffectiveBackgroundImage(
    presentation: IPresentation | undefined,
    device: DeviceType,
    slide: ISlide | undefined
): string | undefined {
    const isDesktop = device === DeviceType.DESKTOP;
    const {slideImage, presentationImage} = selectDeviceImages(isDesktop, slide, presentation);
    return resolveBackgroundImage(slide?.backgroundColor, slideImage, presentationImage);
}

export function useSlideBackground(
    presentation: IPresentation | undefined,
    device: DeviceType,
    slide: ISlide | undefined
): SlideBackground {
    return useMemo(() => {
        const effectiveBackgroundColor = slide?.backgroundColor || presentation?.backgroundColor || SLIDE_COLOR_DEFAULT;
        const effectiveBackgroundImage = getEffectiveBackgroundImage(presentation, device, slide);
        return {effectiveBackgroundColor, effectiveBackgroundImage};
    }, [presentation, device, slide]);
}
